import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TraineeListService } from "../../service/trainee-list.service";

@Component({
    selector: "app-trainee-list",
    templateUrl: "./trainee-list.component.html",
    styleUrl: "./trainee-list.component.scss",
    standalone: false
})
export class TraineeListComponent {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  showNoSearchResultsMessage: boolean = false;
  displayedColumns: string[] = ['wwid','first_name', 'last_name', 'session_count',  'email','last_login']; //  'test_score', 'roleplay_score',
  filterValue: string;
  // dataSource:any= [];
  toggleState: { [key: number]: boolean } = {};
  dataSource:any = new MatTableDataSource();
  Data: any;

  constructor(public Router: Router, private _liveAnnouncer: LiveAnnouncer, public TraineeService: TraineeListService) {}
  ngOnInit(){
    this.TraineeService.getTraineeList().subscribe(res=>{
      this.Data = res;
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
}
  userinfo(wwid: number, allocated_time: number, pending_time: number) {
    this.Router.navigate(['/app-trainee-detail'], { skipLocationChange: true, queryParams: {id: wwid, alloted: allocated_time, pending:pending_time} });
  }
  applyFilter(value: string) {
    this.filterValue = value.trim().toLowerCase();
    this.dataSource.filter = this.filterValue;
     // Check if there are any items after applying the filter
     if (this.dataSource.filteredData.length === 0 && this.filterValue !== '') {
      this.showNoSearchResultsMessage = true; // Set a flag to indicate no search results
    } else {
      this.showNoSearchResultsMessage = false; // Reset the flag
    }
  }

  backbutton() {
    this.Router.navigate(["/app-dashboard-trainer"], { skipLocationChange: true });
  }
  toggle(wwid: number, avtar_enabled: boolean) {
    // this.toggleState[wwid] = !this.toggleState[wwid];
    this.Data.forEach(ele=>{
      if(ele.wwid == wwid){
        ele.avtar_enabled = avtar_enabled;
      }
    });
    this.dataSource = new MatTableDataSource(this.Data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    let ReqData = {
      "wwid": [
        wwid
      ],
      "avtar_enabled": avtar_enabled
    }
    this.TraineeService.updateAvatarStatus(ReqData).subscribe((data: any) => {
    });
    }
  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  convertUtcToLocal(utcDateString: string): Date | null {
    if (!utcDateString) return null;
    const utcDate = utcDateString.split('.')[0] + 'Z';
    return new Date(utcDate);
  }

  processData(data: any[]): any[] {
    return data.map(element => ({
      ...element,
      last_login: this.convertUtcToLocal(element.last_login) 
    }));
  }

}